module.exports = __webpack_public_path__ + "img/audacity.dce446eb.png";